<article
  class="match-card"
  [class.match-card--final]="match.stage === 'final'"
  [class.match-card--compact]="compact"
  [class.match-card--inactive]="inactive"
>
  <header class="match-head">
    <span>Match {{ match.display_match_number }}</span>
    <span class="match-head-meta">
      @if (reportScoreHref) {
        <a class="report-score-link" [routerLink]="reportScoreHref" [queryParams]="reportScoreQueryParams">{{ reportScoreLabel }}</a>
      }
      @if (inactiveLabel) {
        <span class="match-state-pill">{{ inactiveLabel }}</span>
      }
      <span class="match-tag">{{ match.stage === 'final' ? 'Final' : 'Bracket' }}</span>
    </span>
  </header>

  <div class="slot" [class.slot--winner]="isWinningSlot(match.slots[0])">
    <span class="slot-index">1</span>
    <span class="slot-name" [attr.title]="slotName(match.slots[0])">{{ slotName(match.slots[0]) }}</span>
    @if (isWinningSlot(match.slots[0])) {
      <span class="slot-result">Winner</span>
    }
  </div>

  <div class="slot" [class.slot--winner]="isWinningSlot(match.slots[1])">
    <span class="slot-index">2</span>
    <span class="slot-name" [attr.title]="slotName(match.slots[1])">{{ slotName(match.slots[1]) }}</span>
    @if (isWinningSlot(match.slots[1])) {
      <span class="slot-result">Winner</span>
    }
  </div>

  @if (match.winner_team) {
    <footer class="winner">
      <span>Vainqueur</span>
      <strong>{{ match.winner_team.name }}</strong>
    </footer>
  }
</article>
